export default "__VITE_ASSET__D$AnWuBa__"